import styles from './Toggle.module.css';

interface Props {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, disabled = false }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`${styles.track}${checked ? ` ${styles.on}` : ` ${styles.off}`}`}
      onClick={event => {
        // Rows containing the toggle can also be clickable; keep this click
        // local to the switch so state toggles only once.
        event.stopPropagation();
        if (!disabled) {
          onChange();
        }
      }}
    >
      <span className={styles.thumb} />
    </button>
  );
}
